var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calendar_Week",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#CCCCCC;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#ED7261;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Days_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.5,5.5V15c0,0.3-0.2,0.5-0.5,0.5H2c-0.3,0-0.5-0.2-0.5-0.5V5.5h-1v10c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1 v-10H15.5z M3.5,13.5h2C5.8,13.5,6,13.3,6,13v-1.5C6,11.2,5.8,11,5.5,11h-2C3.2,11,3,11.2,3,11.5V13C3,13.3,3.2,13.5,3.5,13.5z  M3.5,10h2C5.8,10,6,9.8,6,9.5V8c0-0.3-0.2-0.5-0.5-0.5h-2C3.2,7.5,3,7.7,3,8v1.5C3,9.8,3.2,10,3.5,10z M7.5,13.5h2 c0.3,0,0.5-0.2,0.5-0.5v-1.5c0-0.3-0.2-0.5-0.5-0.5h-2C7.2,11,7,11.2,7,11.5V13C7,13.3,7.2,13.5,7.5,13.5z M7.5,10h2 C9.8,10,10,9.8,10,9.5V8c0-0.3-0.2-0.5-0.5-0.5h-2C7.2,7.5,7,7.7,7,8v1.5C7,9.8,7.2,10,7.5,10z M11.5,13.5h2 c0.3,0,0.5-0.2,0.5-0.5v-1.5c0-0.3-0.2-0.5-0.5-0.5h-2c-0.3,0-0.5,0.2-0.5,0.5V13C11,13.3,11.2,13.5,11.5,13.5z M11.5,10h2 c0.3,0,0.5-0.2,0.5-0.5V8c0-0.3-0.2-0.5-0.5-0.5h-2C11.2,7.5,11,7.7,11,8v1.5C11,9.8,11.2,10,11.5,10z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Header_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.5,0.5h-14c-0.6,0-1,0.4-1,1v4h16v-4C16.5,0.9,16.1,0.5,15.5,0.5z M6.5,3.5C6.2,3.5,6,3.3,6,3 c0-0.3,0.2-0.5,0.5-0.5C6.8,2.5,7,2.7,7,3C7,3.3,6.8,3.5,6.5,3.5z M10.5,3.5C10.2,3.5,10,3.3,10,3c0-0.3,0.2-0.5,0.5-0.5 S11,2.7,11,3C11,3.3,10.8,3.5,10.5,3.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.90ac51075b9f1ec0dbfe543b5c842b55.svg";
export { ForwardRef as ReactComponent };